import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Programming used to be my biggest stress. I was spending hours every Sunday just planning the week. With FUNCTIONAL PRO™, I had 5 complete sessions ready in under 20 minutes. My clients noticed the difference immediately — everything feels more structured and professional.',
  author: 'James R.',
  role: 'Personal Trainer & Studio Owner',
  location: 'London, UK'
}, {
  text: 'The Exercise Library and the 100 Ready-to-Use Workouts alone are worth 10 times the price. This is not another generic PDF. It is a real professional system that has completely changed how I coach and how my clients experience their sessions.',
  author: 'Sarah M.',
  role: 'Functional Coach',
  location: 'Sydney, AUS'
}, {
  text: "I've been coaching for 8 years and thought I had it all figured out. FUNCTIONAL PRO™ showed me how much time I was wasting reinventing the wheel every week. The Workout Builder System is genius — I can create a full week of programming in 30 minutes now. My client retention has gone up 40% because the sessions are so much more cohesive and progressive.",
  author: 'Marcus T.',
  role: 'Group Fitness Instructor',
  location: 'Toronto, Canada',
  age: 34
}, {
  text: "As a studio owner running 15+ classes a week, I was drowning in programming. The Client Transformation Programs module gave me ready-to-go 4, 8, and 12-week systems that I could immediately implement across all my trainers. We've standardized our quality and my team actually has their weekends back. This system paid for itself in the first week.",
  author: 'Rachel K.',
  role: 'Functional Training Studio Owner',
  location: 'Miami, FL',
  age: 42
}, {
  text: "I was skeptical at first — another 'system' promising to solve everything. But the Session Scriptbook bonus alone transformed how I communicate with clients. I sound more confident, my cues are clearer, and clients are progressing faster because they actually understand what they're doing. The 250+ Exercise Library with progressions and regressions means I never run out of options for any client level.",
  author: 'David L.',
  role: 'Personal Trainer & Online Coach',
  location: 'Manchester, UK',
  age: 29
}];
export function Testimonials() {
  return <section className="py-8 sm:py-10 px-4 bg-white border-y border-brand-gold/30" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        <div className="text-center mb-5" data-id="element-171">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-1" data-id="element-172">
            WHAT YOUR FELLOW COACHES ARE SAYING
          </h2>
          <p className="text-base text-brand-graphite/70" data-id="element-173">
            Testimonials from professionals
          </p>
        </div>

        <div className="space-y-4" data-id="element-174">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/40 p-5 rounded-lg" data-id="element-175">
              <div className="flex gap-1 mb-3" data-id="element-176">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-177" />)}
              </div>
              <p className="text-brand-graphite mb-4 leading-relaxed italic" data-id="element-178">
                "{t.text}"
              </p>
              <div className="border-t border-brand-gold/30 pt-4 flex items-center gap-4" data-id="element-179">
                <div className="w-12 h-12 rounded-full bg-brand-petrol/10 flex items-center justify-center text-brand-petrol font-bold text-lg" data-id="element-180">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-181">
                  <p className="font-bold text-brand-graphite" data-id="element-182">{t.author}</p>
                  <p className="text-sm text-brand-graphite/70" data-id="element-183">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}